import { Action, createReducer, on } from "@ngrx/store";

import { UserPreferencesActions } from "../../actions/user-prefs.actions";
import { UserPreferencesState } from "../../models/user-prefs/user-prefs-state";

const initialState: UserPreferencesState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(UserPreferencesActions.prefs.updateSuccess, (state, action) => ({
		...state,
		preferences: action.preferences,
		loading: false
	})),
	on(UserPreferencesActions.prefs.getSuccess, (state, action) => ({
		...state,
		preferences: action.preferences,
		loading: false
	})),
	on(UserPreferencesActions.prefs.getFail, (state) => ({ ...state, loading: false }))
);

export function userPreferencesReducer(
	state: UserPreferencesState | undefined,
	action: Action
): UserPreferencesState {
	return reducer(state, action);
}
